const firebaseConfig = {
  apiKey: "AIzaSyCaw91TOJaIJzLH5c7yFOMvmtpQwjBcyUk",
  authDomain: "doctors-portal-52744.firebaseapp.com",
  databaseURL: "https://doctors-portal-52744.firebaseio.com",
  projectId: "doctors-portal-52744",
  storageBucket: "doctors-portal-52744.appspot.com",
  messagingSenderId: "335976826950",
  appId: "1:335976826950:web:492c7825283a55ae3c6247"
};
export default firebaseConfig;